module.exports = __webpack_public_path__ + "static/media/nextArrow.957793ed.svg";